import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type {
  ResponseDto,
  ConfirmReactivationResponseDto,
  ConfirmReactivationDto,
} from "@mimber/schema"
import { securityEventsKeys } from "../account.utils"

export const useConfirmReactivation = (
  options?: UseMutationOptions<
    ResponseDto<ConfirmReactivationResponseDto>,
    Error,
    ConfirmReactivationDto
  >
): UseMutationResult<
  ResponseDto<ConfirmReactivationResponseDto>,
  Error,
  ConfirmReactivationDto
> => {
  guardAppUsage("mimber-organization", "useConfirmReactivation")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async (data) => {
      const response = await server.post<
        ResponseDto<ConfirmReactivationResponseDto>
      >("account/confirm-reactivation", data)
      return response.data
    },
    onSuccess: (response, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: securityEventsKeys.findAll(),
      })
      options?.onSuccess?.(response, variables, onMutateResult, context)
    },
  })
}
